(function () {
  const AUTOPLAY_DELAY_MOBILE = 1000;
  const AUTOPLAY_DELAY_DESKTOP = 2000;
  const AUTOPLAY_FIRST_DELAY = 400;
  const AUTOPLAY_DESKTOP_QUERY = '(min-width: 720px)';
  const AUTOPLAY_SLIDES = 2;
  const AUTOPLAY_VISIBLE_RATIO = 0.25;

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function autoplayDelay() {
    if (window.matchMedia && window.matchMedia(AUTOPLAY_DESKTOP_QUERY).matches) {
      return AUTOPLAY_DELAY_DESKTOP;
    }
    return AUTOPLAY_DELAY_MOBILE;
  }

  function canAutoplay(swiper) {
    return !!(swiper && !swiper.destroyed && !swiper.isLocked && !swiper.reviewsAutoplayDone);
  }

  function stopAutoplay(swiper) {
    if (swiper && swiper.reviewsAutoplayTimer) {
      clearTimeout(swiper.reviewsAutoplayTimer);
      swiper.reviewsAutoplayTimer = null;
    }
  }

  function finishAutoplay(swiper) {
    if (!swiper) return;
    stopAutoplay(swiper);
    swiper.reviewsAutoplayDone = true;
  }

  function scheduleAutoplay(swiper, delay) {
    stopAutoplay(swiper);
    swiper.reviewsAutoplayTimer = setTimeout(function () {
      swiper.reviewsAutoplayTimer = null;
      tickAutoplay(swiper);
    }, delay);
  }

  function tickAutoplay(swiper) {
    if (!canAutoplay(swiper) || prefersReducedMotion()) {
      stopAutoplay(swiper);
      return;
    }

    if (document.hidden) {
      scheduleAutoplay(swiper, autoplayDelay());
      return;
    }

    if (swiper.isEnd) {
      swiper.slideTo(0);
      finishAutoplay(swiper);
      return;
    }

    swiper.slideNext();
    scheduleAutoplay(swiper, autoplayDelay());
  }

  function startAutoplay(swiper) {
    if (!canAutoplay(swiper) || prefersReducedMotion()) return;
    if (swiper.reviewsAutoplayTimer) return;

    const delay = swiper.reviewsAutoplayStarted ? autoplayDelay() : AUTOPLAY_FIRST_DELAY;
    swiper.reviewsAutoplayStarted = true;
    scheduleAutoplay(swiper, delay);
  }

  function observeAutoplay(swiper) {
    if (!swiper || prefersReducedMotion()) return;

    if (!window.IntersectionObserver) {
      startAutoplay(swiper);
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!swiper || swiper.destroyed) return;
          if (swiper.reviewsAutoplayDone) {
            observer.disconnect();
            return;
          }
          if (entry.isIntersecting) {
            startAutoplay(swiper);
          } else {
            stopAutoplay(swiper);
          }
        });
      },
      { threshold: AUTOPLAY_VISIBLE_RATIO }
    );

    observer.observe(swiper.el);

    const handOver = function () {
      finishAutoplay(swiper);
      observer.disconnect();
    };

    swiper.on('sliderFirstMove', handOver);
    swiper.on('navigationNext', handOver);
    swiper.on('navigationPrev', handOver);

    swiper.on('destroy', function () {
      observer.disconnect();
      stopAutoplay(swiper);
    });
  }

  function fitQuote(quote) {
    let target = parseFloat(window.getComputedStyle(quote).maxHeight);
    if (!target || isNaN(target)) target = 132;

    quote.style.fontSize = '';
    quote.style.maxHeight = 'none';
    quote.style.overflow = 'visible';

    const min = 10;
    let size = parseFloat(window.getComputedStyle(quote).fontSize) || 16;
    let guard = 0;
    while (quote.scrollHeight > target && size > min && guard < 120) {
      size -= 0.5;
      quote.style.fontSize = size + 'px';
      guard += 1;
    }

    quote.style.maxHeight = target + 'px';
    quote.style.overflow = 'hidden';
  }

  function fitQuotesIn(el) {
    if (!el) return;
    el.querySelectorAll('.reviews__quote').forEach(fitQuote);
  }

  function fitQuotes(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.reviews__quote').forEach(fitQuote);
  }

  function positionNavigation(carousel) {
    if (!carousel) return;
    const wrapper = carousel.closest('.reviews__carousel-wrapper');
    const media = carousel.querySelector('.reviews__media');
    if (!wrapper || !media) return;

    const top = media.offsetTop + media.offsetHeight / 2;
    wrapper.style.setProperty('--reviews-nav-top', top + 'px');
  }

  function initCarousel(carousel) {
    if (!carousel || carousel.swiper) return;

    const wrapper = carousel.closest('.reviews__carousel-wrapper') || carousel.parentNode;
    const nextEl = wrapper.querySelector('[data-reviews-next]');
    const prevEl = wrapper.querySelector('[data-reviews-prev]');

    const refit = function (sw) {
      requestAnimationFrame(function () {
        fitQuotesIn(sw.el);
        positionNavigation(sw.el);
      });
    };

    new Swiper(carousel, {
      slidesPerView: 2,
      slidesPerGroup: AUTOPLAY_SLIDES,
      spaceBetween: 12,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        720: {
          slidesPerView: 3.25,
          slidesPerGroup: AUTOPLAY_SLIDES,
          spaceBetween: 24,
        },
      },
      on: {
        afterInit: function (sw) {
          refit(sw);
          observeAutoplay(sw);
        },
        resize: refit,
        breakpoint: refit,
      },
    });
  }

  function initAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-reviews-carousel]').forEach(initCarousel);
    setTimeout(function () {
      fitQuotes(scope);
    }, 300);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        fitQuotes(scope);
      });
    }
  }

  function whenSwiperReady(callback) {
    if (window.Swiper) {
      callback();
      return;
    }
    let attempts = 0;
    const timer = setInterval(function () {
      attempts += 1;
      if (window.Swiper) {
        clearInterval(timer);
        callback();
      } else if (attempts > 100) {
        clearInterval(timer);
      }
    }, 100);
  }

  function boot() {
    whenSwiperReady(function () {
      initAll(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    whenSwiperReady(function () {
      initAll(event.target);
    });
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const carousel = event.target.querySelector('[data-reviews-carousel]');
    if (carousel && carousel.swiper) {
      carousel.swiper.destroy(true, true);
    }
  });
})();
